import { styled } from '@linaria/react';
import { memo } from 'react';
import { locales } from '../../../locales/en';
import "./NoResults.linaria.module.css!=!./NoResults?./NoResults.linaria.module.css?css=H4sIAAAAAAAAA7WRwW6DMBBE7/kKLpXag5FTkVbCl/6KwQtswWsLb4UjxL9XLW5DSXPMbfVmdjRr53TEauhPZp7QcFcepXxQHWDb8Tp7bQxSK9j5shjBKobIQg/YUlkDMYxKTFD1mKBABhv2UuXibscG0Qywo/8kLG8WDOos1CMAZZpM9mh1FKlj9iqlj09z/ntHEp4L6aMyGPygz+WmxxX7qnGBqdfW+G2465HbBK/r/irgD0zm94/A2JxF7YiB+Ee+gbf/KNWyHPIAroMJ5sYRi2l9tRcp1XL4BGzexZMVAgAA"
const NoResultsContainer = /*#__PURE__*/styled('div')({
  name: "NoResultsContainer",
  class: "n1iblk5d",
  propsAsIs: false
});
const SearchQuery = /*#__PURE__*/styled('span')({
  name: "SearchQuery",
  class: "seohewe",
  propsAsIs: false
});
interface INoResults {
  styleOverrides?: any;
  searchQuery?: string;
}
const NoResults = (props: INoResults) => {
  const {
    searchQuery = null,
    styleOverrides
  } = props;
  return searchQuery && searchQuery !== '' ? <NoResultsContainer data-testid="Container__EmptySearchResults" className={styleOverrides}>
            <p>
                {locales.search.sorryNothingCameUpFor} &quot;
                <SearchQuery>{searchQuery}</SearchQuery>
                &quot;.
            </p>
        </NoResultsContainer> : <NoResultsContainer data-testid="Container__EmptySearchResults" className={styleOverrides}>
            <p>{locales.search.sorryNothingCameUp}</p>
        </NoResultsContainer>;
};
export default memo(NoResults);